import { render, staticRenderFns } from "./GChatBrandInfoPc.vue?vue&type=template&id=d4f06322&scoped=true&"
import script from "./GChatBrandInfoPc.vue?vue&type=script&lang=ts&"
export * from "./GChatBrandInfoPc.vue?vue&type=script&lang=ts&"
import style0 from "./GChatBrandInfoPc.vue?vue&type=style&index=0&id=d4f06322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f06322",
  null
  
)

export default component.exports